import React, { useMemo } from "react";
import { Button, Header, Segment } from "semantic-ui-react";

import { useApp, useLanguage, useRoutes } from "../hooks/";

import styles from "../assets/styles/notFound.module.css";

type Props = {
    buttonText: string;
    route: string;
};

const NotFound = (props: Props): JSX.Element => {
    const { buttonText, route } = props;

    const { t, language } = useLanguage();

    const { theme } = useApp();

    const { navigate } = useRoutes();

    const { text, _buttonText } = useMemo(
        () => ({
            text: t("The page you requested was not found"),
            _buttonText: t(buttonText),
        }),
        [language]
    );

    const handleOnHomeClick = () => {
        navigate(route);
    };

    return (
        <Segment inverted={theme.inverted}>
            <div className={styles.notfound}>
                <div className={styles.notfound404}>
                    <Header as="h1" inverted={theme.inverted}>
                        4<span>0</span>4
                    </Header>
                </div>
                <Header as="h2" inverted={theme.inverted} color="grey">
                    {text}
                </Header>
                <div className={styles.notfoundButton}>
                    <Button
                        type="button"
                        inverted
                        color="blue"
                        icon="reply"
                        content={_buttonText}
                        onClick={handleOnHomeClick}
                    />
                </div>
            </div>
        </Segment>
    );
};

export default NotFound;
